export enum PersonalAccountActionsEnum {
  PERSONAL_ACCOUNT_GET_KNM_INSPECTORS = 'PERSONAL_ACCOUNT_GET_KNM_INSPECTORS',
  PERSONAL_ACCOUNT_UPDATE_KNM_INSPECTORS = 'PERSONAL_ACCOUNT_UPDATE_KNM_INSPECTORS',
  PERSONAL_ACCOUNT_UPDATE_PASSWORD = 'PERSONAL_ACCOUNT_UPDATE_PASSWORD',
}
